export default __webpack_public_path__ + "static/chart-lending-de-848e8f11f824b57280b3ed3b9d8feb7b.svg";